export const COOKIE_CLIENT_DASHBOARD_QUESTIONS =
  'CLIENT_DASHBOARD_QUESTIONS' as const;

export const COOKIE_CLIENT_CLIENT_ENTRIES =
  'COOKIE_CLIENT_CLIENT_ENTRIES' as const;

export const OVERVIEW_COLUMNS_COOKIE =
  'OVERVIEW_COLUMNS_COOKIE_20250116' as const;
export const OVERVIEW_FILTERS_COOKIE =
  'OVERVIEW_FILTERS_COOKIE_20250117' as const;

export const OVERVIEW_PAGE_SIZE_COOKIE =
  'OVERVIEW_PAGE_SIZE_COOKIE_20250117' as const;
export const OVERVIEW_FIRM_ROLE_ID_COOKIE =
  'OVERVIEW_FIRM_ROLE_ID_COOKIE' as const;

export const ENTITIES_FIRM_ROLE_ID_COOKIE =
  'ENTITIES_FIRM_ROLE_ID_COOKIE' as const;
export const ENTITIES_COLUMNS_COOKIE =
  'ENTITIES_COLUMNS_COOKIE_20250115' as const;
export const ENTITIES_PAGE_SIZE_COOKIE = 'ENTITIES_PAGE_SIZE_COOKIE' as const;
export const ENTITIES_PAGE_COLUMNS_COOKIE =
  'ENTITIES_PAGE_COLUMNS_COOKIE' as const;

export const REVIEW_AND_EXPORT_PAGE_SIZE_COOKIE =
  'REVIEW_AND_EXPORT_PAGE_SIZE_COOKIE' as const;
export const REVIEW_AND_EXPORT_FILTERS_COOKIE =
  'REVIEW_AND_EXPORT_FILTERS_COOKIE_20250117' as const;

export const USERS_PAGE_SIZE_COOKIE = 'USERS_PAGE_SIZE_COOKIE' as const;

export const TAX_RETURNS_PAGE_SIZE_COOKIE =
  'TAX_RETURNS_PAGE_SIZE_COOKIE' as const;

export const SORABAN_YEAR_COOKIE = 'SORABAN_YEAR_COOKIE_20241213' as const;

export const MAX_COOKIE_AGE = 60 * 60 * 24 * 365; // 1 year

export const SORABAN_GLOBAL_BANNER_COOKIE =
  'SORABAN_GLOBAL_BANNER_COOKIE' as const;

export const REVIEW_APP_NAME_FROM_API_E2E_TESTS_COOKIE =
  'REVIEW_APP_NAME_FROM_API_E2E_TESTS_COOKIE' as const;

export const IS_WORKOS_API_E2E_TESTS_COOKIE =
  'IS_WORKOS_API_E2E_TESTS_COOKIE' as const;

export const SORABAN_AUTH_TOKEN = 'firebase__authToken' as const;

export const CONTACT_METHOD_PREFERENCE_COOKIE = (userId: number) =>
  `CONTACT_METHOD_PREFERENCE_COOKIE_${userId}` as const;
